import type { IconProps } from "@/types/IconProps";

export function Pen(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12 6.201 22.5 12 22.5V24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12v-1.5c5.799 0 10.5-4.701 10.5-10.5"></path>
      <g clipPath="url(#clip0_28_200)">
        <path d="M16.166 7.61a.778.778 0 0 0-1.326-.55l-.651.651 1.098 1.099.652-.65a.78.78 0 0 0 .227-.55m.21 8.015a.75.75 0 0 1 0 1.5H12.04a.75.75 0 0 1 0-1.5zM7.61 14.292a.33.33 0 0 0-.083.139l-.001-.001-.454 1.496 1.499-.454a.33.33 0 0 0 .137-.082l5.518-5.52-1.099-1.098zM17.666 7.61c0 .604-.24 1.183-.667 1.61l-1.119 1.119a.8.8 0 0 1-.125.125L9.77 16.451a1.84 1.84 0 0 1-.762.456l-2.358.715-.002.001a1.02 1.02 0 0 1-1.015-.255 1.02 1.02 0 0 1-.257-1.015l.001-.003.715-2.358.001-.002c.088-.287.245-.548.458-.76l5.986-5.988a.8.8 0 0 1 .122-.123L13.78 6a2.278 2.278 0 0 1 3.887 1.61"></path>
      </g>
      <defs>
        <clipPath id="clip0_28_200">
          <path fill="#fff" d="M5 5h13v13H5z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
